import { z } from 'zod';

export const MsTeamsStatusSchema = z.object({
	// No 'expired' state — tokens are refreshed transparently by the server
	status: z.enum(['connected', 'not_connected']),
});
export type MsTeamsStatus = z.infer<typeof MsTeamsStatusSchema>;

export const MsTeamsAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type MsTeamsAuthorize = z.infer<typeof MsTeamsAuthorizeSchema>;

export const MsTeamsDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type MsTeamsDisconnect = z.infer<typeof MsTeamsDisconnectSchema>;
